import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardContent,
  Typography,
  Divider,
  TextField,
  useTheme,
  Grid,
} from "@mui/material";

export default function DetailsLoad({ props, inspectionData }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const [inspection, setInspection] = useState(inspectionData);

  return (
    <Card
      variant="outlined"
      sx={{
        overflow: "hidden",
        boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        borderRadius: 2,
        maxWidth: "calc(100% - 32px)",
        margin: "auto",
        marginTop: 2,
      }}
    >
      <CardContent sx={{ maxWidth: "calc(100% - 64px)", margin: "auto" }}>
        <Typography
          variant="h5"
          sx={{
            flex: "1",
            color: theme.palette.primary.main,
          }}
        >
          {t("loads.addOrEdit.loadInfo")}
        </Typography>
        <Divider sx={{ maxWidth: "100%", marginTop: 2 }} />
        <Grid container spacing={2} sx={{ marginTop: 2 }}>
          <Grid item xs={12} md={3}>
            <TextField
              label={t("loads.addOrEdit.load")}
              name="Carga"
              variant="standard"
              fullWidth
              value={inspection?.inspectionMontaje.noCarga || t("pagination.notAvailable")}
              InputProps={{ disableUnderline: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label={t("loads.addOrEdit.client")}
              name="cliente"
              variant="standard"
              fullWidth
              value={inspection?.inspectionMontaje.cliente || t("pagination.notAvailable")}
              InputProps={{ disableUnderline: true }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
